import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { formDecryptUrl } from "../../../../../actions/forms";
import LoadingComponent from "../../../../commons/loadingData/loading";


const PublicResponsiveFormContainer = () => {
  const { encryptedParameters } = useParams();
  const dispatch = useDispatch();
  const { isFetching, didInvalidate, data } = useSelector((state) => state.forms.formDecryptUrl);

  useEffect(() => {
    dispatch(formDecryptUrl(encryptedParameters));
  }, [encryptedParameters])

  return (
    <LoadingComponent finishLoadingText={didInvalidate ? "La dirección a la que intenta ingresar ha expirado, por favor generela nuevamente" : null} />

  )
}

export default PublicResponsiveFormContainer;
